import { GuaranteeNoticeCTA } from "./components/guaranteeNotice/guaranteeNoticeCTA";
import { Pagination } from "./components/pagination/pagination";
import { Base } from "./footer.base";

export const Footer = Object.assign(Base, {
    Pagination: Pagination,
    GuaranteeNotice: GuaranteeNoticeCTA
});
